import { api, type RequestOptions } from "./client";

export interface PlanStepDto {
  step_id:        string;
  kind:           string;
  params:         Record<string, unknown>;
  status:         "pending" | "running" | "completed" | "failed" | "skipped";
  result:         Record<string, unknown> | null;
  error_message:  string | null;
  started_at:     number | null;
  finished_at:    number | null;
}

export interface PlanDto {
  plan_id:          string;
  correlation_id:   string;
  intent:           string;
  goal_text:        string;
  status:           "pending" | "running" | "completed" | "failed";
  current_step_idx: number;
  steps:            PlanStepDto[];
  final_response:   string | null;
  created_at:       string;       // ISO datetime
  completed_at:     string | null;
}

export interface TaskAcceptedDto {
  correlation_id: string;
  event_id:       string;
}

export const dispatcherApi = {
  postTask(text: string, opts?: RequestOptions): Promise<TaskAcceptedDto> {
    return api.post<TaskAcceptedDto>("/dispatcher/task", { text }, opts);
  },

  getPlanById(planId: string, opts?: RequestOptions): Promise<PlanDto> {
    return api.get<PlanDto>(`/dispatcher/plans/${planId}`, opts);
  },

  getPlanByCorrelation(correlationId: string, opts?: RequestOptions): Promise<PlanDto> {
    return api.get<PlanDto>(
      `/dispatcher/plans?correlation_id=${encodeURIComponent(correlationId)}`,
      opts,
    );
  },
};
